import React, {useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import {AppBar, Toolbar, DialogContent, Typography} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

import {register, unregister} from "../../domain/socketSlice";
import {api} from "../../maps/data.js";
import styled from "styled-components";
import {colors} from "../../maps/colors";
import Icn from "../Icn";
import useZibi from "../../zibi/UseZibi";
import {CAMERA_TYPE_ENUM} from "../../maps/data_types";
import CameraPoseDetection from "../camera/CameraPoseDetection";
import ShelveItem from "../field/ShelveItem";
import CameraShelfMarkerEditor from "../camera/CameraShelfMarkerEditor";

const NahuiGrid = styled.div`
    height: 'calc(100vh - 10px)';
`;

const DialogWrapperStyled = styled.div`
    transition: 0.4s ease;
    display: grid;
`;

const ContetnWrapper = styled.div`
    height: 50%;
    display: block;
    position: relative;
    width: 100%;
`;

const ShelfsWrapperStyled = styled.div`
    height: 100%;
    width: 900px;
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 30px;
`;

const ShelfItemWithCameraStyled = styled.div`
    
`;

const PoseCameraWrapper = styled.div`
    width: 930px;
    margin-top: 30px;
`;

const PlayBoxDialog = (props) => {
    const {onClose, boxName, siteId, edgeId} = props;

    const [productsById, set_productsById] = useZibi('productsById');
    const [productsByBarCode, set_productsByBarCode] = useZibi('productsByBarCode');
    const [, set_shopperProductsCart] = useZibi('shopperProductsCart');

    const [fields, s_fields] = useState([]);
    const [edges, s_edges] = useState(null);
    const [productsDetection, s_productsDetection] = useState([]);
    const [shelvesDetection, s_shelvesDetection] = useState([]);
    const [poseDetection, s_poseDetection] = useState([]);
    const [indications, s_indications] = useState({});

    const [shoppers_map, s_shoppers_map] = useState([]);
    const [shopperOnline_list, s_shopperOnline_list] = useState([]);

    const eventName = `play-mode-data-${edgeId}`;

    useEffect(() => {
        register(eventName);
        window.addEventListener(eventName, onPlayModeData);
        window.c = 0;

        return () => {
            unregister(eventName);
            window.removeEventListener(eventName, onPlayModeData);
        };
    }, []);

    useEffect(() => {
        api({
            'type': 'setSitePlayMode', 'data': {
                boxId: edgeId, enabled: true
            },
        });

        // load site data
        api({
            type: 'getEdges', data: {edgeId}
        }).then((r) => {
            s_edges(r);
        });
    }, []);

    useEffect(() => {
        if (!Object.keys(productsByBarCode).length) {
            api({
                type: 'getProducts', data: {allProducts: true, ignoreCategory: true}
            }).then(({products}) => {
                const temp = {};
                for (let i = 0; i < products.length; i++) {
                    const product = products[i];
                    temp[product.barcode] = product;
                    productsById[product._id] = product;
                }
                set_productsByBarCode(temp);
                set_productsById({...productsById});
            });
        }
    }, []);

    const getFields = async () => {
        const res = await api({
            type: 'getFields',
            data: {
                edgeId: edgeId
            }
        });
        s_fields(res);
    };

    useEffect(() => {
        getFields();
    }, [edgeId]);

    useEffect(() => {
        getShoppersCart();
    }, []);

    const getShoppersCart = async () => {
        api({
            type: 'getShopperCart', data: {siteId}
        }).then(data => {
            const tempObj = {};
            data.forEach(item => {
                if (!tempObj[item.shopperId]) {
                    tempObj[item.shopperId] = {
                        cart: []
                    };
                }
                item.products.forEach(pro => {
                    tempObj[item.shopperId].cart.push({productId: pro.productId});
                });
            });
            set_shopperProductsCart(tempObj);
        });
    };

    const getShoppers = () => {
        api({
            type: 'getShoppers',
            disableBI: true,
            data: {nonAnon: true}
        }).then(shoppers => s_shoppers_map(shoppers));
        api({
            type: 'getOnlineShoppers',
            disableBI: true
        }).then(shoppers => s_shopperOnline_list(shoppers));
    };

    const onPlayModeData = async playModeData => {
        const {type, circles, shopperId, productId, data} = playModeData.detail;

        switch (type) {
            case 'shopperEnter':
                await getShoppers();
                break;
            case 'shopperLeft':
                await getShoppers();
                break;
            case 'addProductToCart':
                await productCartHandle(productId, shopperId);
                break;
            case 'removeProductFromCart':
                await productCartHandle(productId, shopperId, true);
                break;
            case 'productDetection':
                productDetectionHandle(data);
                break;
            case 'shelvesDetection':
                data?.length && s_shelvesDetection(data);
                break;
            case 'poseDetection':
                s_poseDetection(data);
                break;
            case 'eventUpdated':
                getShoppersCart();
                break;
            default:
                console.error("this type is not handled");
        }
    };

    const productCartHandle = async (productId, shopperId, isRemove) => {
        if (isRemove) {
            set_shopperProductsCart(prevItems => {
                const newShopperCartObj = {...prevItems};
                let removed = false;
                const newCart = newShopperCartObj?.[shopperId]?.cart?.filter(prod => {
                    if (prod.productId === productId && !removed) {
                        removed = true;
                        return false;
                    }
                    return true;
                });
                newShopperCartObj[shopperId] = {...(newShopperCartObj[shopperId] || {}), cart: newCart};
                return newShopperCartObj;
            });
        } else {
            let product = null;
            if (productsById[productId]) {
                product = productsById[productId];
            } else {
                const {products} = await api({
                    type: 'getProducts',
                    data: {ignoreCategory: true, productIds: [productId]}
                });
                if (products.length) {
                    product = products[0];
                    productsById[productId] = product;
                    set_productsById({...productsById});
                }
            }
            if (product) {
                set_shopperProductsCart(prevItems => {
                    const newShopperCartObj = {...prevItems};
                    if (!newShopperCartObj[shopperId]?.cart) {
                        newShopperCartObj[shopperId] = {
                            cart: []
                        };
                    }
                    newShopperCartObj?.[shopperId]?.cart?.unshift({productId});
                    return newShopperCartObj;
                });
            }
        }
    };
    const productDetectionHandle = data => {
        if (data?.length) {
            s_productsDetection(data);
        }
    };

    function handleClose(e) {
        api({
            'type': 'setSitePlayMode', 'data': {
                boxId: edgeId, enabled: false
            },
        });

        onClose(e);
    }

    const showDrawer = false;

    const field = fields?.[0];

    const shelves = field?.shelves;
    const shelvesExits = !!shelves?.length;

    const cameras = field?.cameras || [];
    const topCamera = cameras.find(cam => cam.cameraType === 'TOP');
    const camerasWithoutTop = cameras.filter(cam => cam.cameraType !== CAMERA_TYPE_ENUM.TOP);
    const topCameraBorder = topCamera?.cameraBorder;

    const topCameraExists = topCamera && Object.keys(topCamera).length > 0;

    const filteredPoseData = poseDetection.find(pp => pp.cameraId === topCamera?._id);

    return (
        <Dialog
            open={true}
            onClose={handleClose}
            fullScreen={true}>

            <AppBar sx={{position: 'relative'}}>
                <Toolbar style={{background: colors.GRAY4, minHeight: 60}}>
                    <CloseIcon
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"/>
                    <Typography sx={{ml: 2, flex: 1}} variant="h6" component="div">
                        <Icn style={{position: 'relative', top: 4, color: 'white'}}>store</Icn>
                        [{boxName}]
                    </Typography>
                </Toolbar>
            </AppBar>

            <DialogWrapperStyled style={{
                gridTemplateColumns: showDrawer ? '80% 20%' : '100% 0'
            }}>
                <DialogContent style={{background: colors.GRAY3}}>
                    <NahuiGrid>
                        <ContetnWrapper>
                            <ShelfsWrapperStyled className="poiuytrew">
                                {camerasWithoutTop.map((cam, idx) => {
                                    const shelvesForThisCamera = [];
                                
                                    if (shelvesExits) {
                                        shelves.forEach(sh => {
                                            const isForCamera = sh.boundingBoxes.find(pp => pp.cameraId === cam._id);
                                            if (isForCamera) {
                                                shelvesForThisCamera.push(sh);
                                            }
                                        });
                                    }
                                
                                    return (
                                        <ShelfItemWithCameraStyled key={cam._id + field?.name + idx}>
                                            <CameraShelfMarkerEditor
                                                shelves={shelves}
                                                camera={cam}
                                                key={cam._id + field?.name + idx}
                                                disableControls={true}
                                                isPreview={true}
                                                productsDetection={productsDetection}
                                            />
                                            {shelvesForThisCamera.map((shelf, idx) => {
                                                const productsItems = productsDetection.filter(pd => {
                                                    return pd.sensorId === shelf.sensorId;
                                                });
                                
                                                const shelfsItem = shelvesDetection.find(sd => {
                                                    return sd.sensorId === shelf.sensorId;
                                                });
                                
                                                const shelfIndications = indications[shelf.sensorId];
                                
                                                const camerasForThisShelf = [];
                                                shelf?.boundingBoxes?.forEach(box => {
                                                    const camera = camerasWithoutTop.find(cam => cam._id === box.cameraId);
                                                    if (camera) {
                                                        camerasForThisShelf.push(camera);
                                                    }
                                                });
                                
                                                const productsItem = productsItems.find(pd => {
                                                    return pd.cameraId === cam.cameraId;
                                                });
                                
                                                return (
                                                    <ShelveItem
                                                        key={idx + cam._id}
                                                        rotate={cam?.rotate}
                                                        cameraId={cam?._id}
                                                        fieldSize={400}
                                                        shelf={shelf}
                                                        field={field}
                                                        products={productsItem?.products}
                                                        shelfShapes={shelfsItem?.results}
                                                        indications={shelfIndications?.items}
                                                        showProductImages={true}
                                                        style={{
                                                            display: "grid",
                                                            gridTemplateColumns: "1fr 1fr"
                                                        }}
                                                    />
                                                );
                                            })}
                                        </ShelfItemWithCameraStyled>
                                    );
                                })}
                            </ShelfsWrapperStyled>
                        </ContetnWrapper>
                        <ContetnWrapper>
                            {topCameraExists && (
                                <PoseCameraWrapper>
                                    <CameraPoseDetection
                                        poseDetection={filteredPoseData}
                                        camera={topCamera}
                                        field={field}
                                        key={topCamera._id + field?.name}
                                        disableControls={true}
                                        isPreview={true}
                                        topCameraBorder={topCameraBorder}
                                    />
                                </PoseCameraWrapper>
                            )}
                        </ContetnWrapper>
                    </NahuiGrid>
                </DialogContent>
            </DialogWrapperStyled>

        </Dialog>
    );
};

export default PlayBoxDialog;